import { render, staticRenderFns } from "./brandCenter.vue?vue&type=template&id=c5544e78&"
import script from "./brandCenter.vue?vue&type=script&lang=js&"
export * from "./brandCenter.vue?vue&type=script&lang=js&"
import style0 from "./brandCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports